import React, {useState} from "react";
import {useLocation} from "react-router-dom";
import {MenuMaterialForm, MenuMaterialFormValues} from "../../components/pages/admin/MenuMaterial/MenuMaterialForm";
import {useSystemMessage} from "../../hooks/useSystemMessage";
import useAppRouter from "../../hooks/useAppRouter";
import {menuMaterialApi} from "../../apis/admin/menu/menuMaterialApi";
import {MenuMaterialType} from "../../enum/menuMaterial/MenuMaterialType";
import {ApiClientError} from "../../apis/errors";
import {logError} from "../../libs/utils/logError";

export const MenuMaterialCreatePage: React.FC = () => {
  const defaultValues: MenuMaterialFormValues = {
    name: '',
    content: '',
    materialTypeId: MenuMaterialType.URL,
    level: null,
    webUrl: '',
    filename: null,
    attachment: null,
  }
  const { success } = useSystemMessage();
  const [ abortController, setAbortController ] = useState<AbortController | undefined>();
  const [ apiClientError, setApiClientError ] = useState<ApiClientError | null>(null);
  const { goto } = useAppRouter();
  const location = useLocation();

  const clearApiClientError = async (): Promise<void> => {
    setApiClientError(null);
  }

  const onSave = async (data: MenuMaterialFormValues): Promise<void> => {
    setAbortController(new AbortController());
    try {
      await menuMaterialApi.create(
        {
          name: data.name,
          content: data.content,
          materialTypeId: data.materialTypeId,
          webUrl: data.materialTypeId === MenuMaterialType.URL ? data.webUrl : null,
          level: data.materialTypeId !== MenuMaterialType.URL ? 1 : null,
          filename: data.materialTypeId !== MenuMaterialType.URL ? data.filename : null,
          attachment: data.materialTypeId !== MenuMaterialType.URL ? data.attachment : null,
        },
        { abortSignal: abortController?.signal });
      setAbortController(undefined);
      await success('メニュー資料を作成しました。');
      goto('menuMaterialList')

    } catch (e) {
      await logError(
        location.pathname,
        'メニュー資料の作成に失敗しました。',
        e
      );

      if (e instanceof ApiClientError) {
        setApiClientError(e);
        return;
      }

      goto('internalServerError');
    }
  }

  return (
    <>
      <MenuMaterialForm
        {...{
          defaultValues,
          isEdit: false,
          apiClientError,
          clearApiClientError,
          onSave,
        }}
      />
    </>
  );
}
